/**
 * Asynchronously loads the component for ForbiddenPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
